module.exports = __webpack_public_path__ + "static/font-50dcd694bd1740a214f6c8c423586b9c.woff2";